import React from 'react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-steel py-5 sm:py-8" data-id="element-159" data-mp="3gihoxkzfi0s2">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-160" data-mp="3bimwhd00934w">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-161" data-mp="3bhbwlo9okfj2">
          Everything you need.{' '}
          <span className="text-electric" data-id="element-162" data-mp="36lwlv56yyzqv">One complete diagnostic system.</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-bold uppercase tracking-wide text-graphite sm:text-base" data-id="element-163" data-mp="31mtng3lhvrrv">
          6 Professional Diagnostic Resources In One Organized System
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-lg border-2 border-navy bg-white p-3.5 text-center sm:p-5" data-id="element-164" data-mp="2sq16387va4rp">
          <p className="font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-165" data-mp="2iu7tjou5eb9x">
            🔧 {PRODUCT} — Complete 6-in-1 Fault-Finding System
          </p>
          <div className="mt-2 space-y-1.5 text-sm font-medium leading-snug text-muted sm:text-base" data-id="element-166" data-mp="2dxh78jrr2jg2">
            <p data-id="element-167" data-mp="18py2wmowepkm">
              Home Appliance Diagnostic Pro™ brings electrical testing, component
              diagnosis, refrigerator, washing machine, dryer, dishwasher, oven, and range
              troubleshooting together in one organized visual system.
            </p>
            <p data-id="element-168" data-mp="z0emroskl9tg">
              From diagnostic fundamentals and component testing to appliance-specific
              symptoms, troubleshooting paths, and fault isolation, you get structured
              visual resources designed to help you understand what to check and why.
            </p>
          </div>
          <p className="mx-auto mt-2.5 w-fit rounded bg-navy px-3 py-1 font-display text-sm font-extrabold uppercase tracking-widest text-white sm:text-lg" data-id="element-169" data-mp="1ctmav6hfzn6e">
            Identify → <span className="text-electric" data-id="element-170" data-mp="1blbehh795zx">Check</span> → Test →{' '}
            <span className="text-electric" data-id="element-171" data-mp="6bz8j4h9ivj6">Isolate</span>
          </p>
          <p className="mt-2 text-sm font-semibold leading-snug text-navy sm:text-base" data-id="element-172" data-mp="693brjh5icwb">
            Spend less time searching through scattered references—and more time
            following a structured diagnostic process.
          </p>
        </div>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-173" data-mp="1z70gdljrl48n">
          {modules.map(module => <article key={module.title} className="rounded-lg border border-white bg-white p-3.5 shadow-sm sm:p-4" style={{
          borderLeft: `5px solid ${module.color}`
        }} data-id="element-174" data-mp="1u8fe7gkycahk">
              <h3 className="flex items-start gap-1.5 text-[15px] leading-tight text-navy sm:text-lg" data-id="element-175" data-mp="1l78yh9q4n3pd">
                <span className="text-electric" aria-hidden="true" data-id="element-176" data-mp="1gbjsoonikqkm">
                  ✓
                </span>
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-177" data-mp="3amfe4rjss04t">{module.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}